import React from "react";
import { Button, DownloadIcon } from "@pd/pd-ui-kit";
import { get } from "lodash";

import { useAppeals } from "~/entity/Appeals";
import { IAppealGetterParams } from "~/entity/Appeals/model/schema";
import { useNotify } from "~/shared/hooks/useNotify";

import s from "./AppealsControl.less";

interface IAppealsControlProps {
  onDownload: () => void;
  disabledControl?: boolean;
  filter?: IAppealGetterParams;
}

export const AppealsControl = (props: IAppealsControlProps) => {
  const { onDownload, disabledControl, filter } = props;
  const { getAppealReport } = useAppeals();
  const { notifyReport } = useNotify();

  const handleDownload = async () => {
    if (!filter) {
      onDownload();
      return;
    }

    try {
      const response = await getAppealReport(filter);
      const fileHash = get(response, "data.fileHash");

      if (fileHash) {
        notifyReport(fileHash);
      }
    } catch (error) {
      console.error("Ошибка при загрузке отчета:", error);
    }
  };

  return (
    <div>
      <Button
        size="middle"
        className={s.downloadBtn}
        icon={<DownloadIcon size={16} fill="#495a64" />}
        onClick={handleDownload}
        disabled={disabledControl}
      >
        {"Выгрузить Excel"}
      </Button>
    </div>
  );
};
